export function fixedSectionAnimation() {
    const fixedSection = $('.fixed-animation');
    const fixedSectionHolder = fixedSection.find('.fixed-animation-holder');
    const fixedSectionInner = fixedSection.find('.fixed-animation-inner');
    const fixedSectionPadding = parseInt(fixedSection.css('padding-top'));

    function setSectionHeight() {
        if (window.innerWidth > 1199) {
            const fixedSectionHeight = fixedSectionInner.innerHeight();
            const paddingTop = parseInt(fixedSection.css('padding-top'));

            fixedSectionHolder.css({
                'height': (fixedSectionHeight * 2) + fixedSectionPadding,
                'margin-bottom': -(fixedSectionHeight + paddingTop)
            });
        } else {
            fixedSectionHolder.removeAttr('style');
        }
    }

    $(window).on("load resize", function () {
        setSectionHeight();
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/fixedSectionAnimation.js